import { createClient } from "@supabase/supabase-js";

const url = ((import.meta.env.VITE_PUBLIC_SUPABASE_URL as string) || "").replace(/\/+$/, "");
const key = (import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string) || "";

// Shared backend with the ISMAN admin panel (admin.isman.co.ke).
export const supabase = createClient(url, key, {
  auth: { persistSession: false, autoRefreshToken: false },
});
